import i18n from "i18next";

export function columnsContractTerms() {
  return [
    {
      id: "term_short",
      label: i18n.t("column.short_description"),
      minWidth: 110,
      maxWidth: 150,
      align: "left",
    },
    {
      id: "term_description",
      label: i18n.t("column.description"),
      minWidth: 200,
      maxWidth: 600,
      align: "left",
    },
  ];
}
